function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors } from '@airwallex/global';
import color from 'color';
import { darken, lighten } from 'polished';

var generateStates = function generateStates(_ref) {
  var bg = _ref.bg,
      hover = _ref.hover,
      active = _ref.active;
  return _objectSpread(_objectSpread({
    '&:hover': {
      backgroundColor: lighten(0.04, bg)
    },
    '&:focus': {
      backgroundColor: lighten(0.08, bg) // maybe get rid of this?

    },
    '&:active': {
      backgroundColor: lighten(0.16, bg)
    }
  }, hover && {
    backgroundColor: lighten(0.04, bg)
  }), active && {
    backgroundColor: lighten(0.16, bg)
  });
}; // Generate background styles


var generateColouredBackground = function generateColouredBackground(_ref2) {
  var bg = _ref2.bg,
      link = _ref2.link,
      hover = _ref2.hover,
      active = _ref2.active;
  return _objectSpread(_objectSpread({
    '&:hover': {
      background: darken(0.05, bg)
    },
    '&:focus': _objectSpread({}, !link && {
      backgroundColor: darken(0.1, bg)
    }),
    '&:active': {
      background: darken(0.1, bg)
    }
  }, hover && {
    background: darken(0.05, bg)
  }), active && {
    background: darken(0.1, bg)
  });
};

var transparentHover = function transparentHover(theme) {
  return {
    background: theme.colors.ultraVioletLightest,
    boxShadow: "inset 0 0 0 1px ".concat(theme.colors.ultraVioletLight)
  };
};

var transparentActive = function transparentActive(theme) {
  return {
    background: theme.colors.ultraVioletLight,
    boxShadow: "inset 0 0 0 1px ".concat(theme.colors.ultraVioletLight)
  };
}; // Generate secondary styles


var generateTransparentDepth = function generateTransparentDepth(_ref3) {
  var link = _ref3.link,
      hover = _ref3.hover,
      active = _ref3.active,
      theme = _ref3.theme;
  return _objectSpread(_objectSpread({
    '&:hover': transparentHover(theme),
    '&:focus': _objectSpread(_objectSpread({}, !link && {
      background: theme.colors.ultraViolets[10]
    }), {}, {
      boxShadow: "inset 0 0 0 1px ".concat(theme.colors.ultraVioletLight)
    }),
    '&:active': transparentActive(theme)
  }, hover && transparentHover(theme)), active && transparentActive(theme));
};

var activeLinkStyle = function activeLinkStyle(theme) {
  return {
    background: theme.colors.ultraVioletLight
  };
};

export var linkButtonStyles = function linkButtonStyles(_ref4) {
  var disabled = _ref4.disabled,
      variant = _ref4.variant,
      dropdownButtonShowMenu = _ref4.dropdownButtonShowMenu,
      hover = _ref4.hover,
      active = _ref4.active,
      theme = _ref4.theme;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, variant === 'PRIMARY' && {
    color: theme.colors.darkGrey
  }), {}, {
    backgroundColor: 'transparent'
  }, !disabled && {
    '&:hover': {
      background: theme.colors.ultraViolets[10]
    },
    '&:active': activeLinkStyle(theme)
  }), dropdownButtonShowMenu && _objectSpread(_objectSpread({}, activeLinkStyle(theme)), {}, {
    '&:hover': activeLinkStyle(theme)
  })), hover && {
    background: theme.colors.ultraViolets[10]
  }), active && activeLinkStyle(theme));
};
export var colouredButtonStyles = function colouredButtonStyles(_ref5) {
  var link = _ref5.link,
      variant = _ref5.variant,
      disabled = _ref5.disabled,
      bg = _ref5.bg,
      foreground = _ref5.foreground,
      _ref5$depthMode = _ref5.depthMode,
      depthMode = _ref5$depthMode === void 0 ? 'none' : _ref5$depthMode,
      hover = _ref5.hover,
      active = _ref5.active;
  var fontColor = link ? variant === 'DEFAULT' ? foreground : bg : foreground;
  return _objectSpread(_objectSpread(_objectSpread(_defineProperty({
    color: fontColor,
    backgroundColor: link ? 'transparent' : bg
  }, "&:hover,\n      &:focus", {
    color: fontColor
  }), depthMode === 'shadow' && !link && !disabled && generateStates({
    bg: bg,
    variant: variant,
    link: link,
    hover: hover,
    active: active
  })), depthMode === 'background' && !link && !disabled && generateColouredBackground({
    bg: bg,
    link: link,
    hover: hover,
    active: active
  })), link && {
    '&:focus': {
      color: darken(0.1, fontColor)
    }
  });
};
export var secondaryButtonStyles = function secondaryButtonStyles(_ref6) {
  var bg = _ref6.bg,
      foreground = _ref6.foreground,
      link = _ref6.link,
      disabled = _ref6.disabled,
      hover = _ref6.hover,
      active = _ref6.active,
      theme = _ref6.theme;
  var fontColor = foreground;
  return _objectSpread(_objectSpread(_defineProperty({
    color: fontColor,
    backgroundColor: link ? 'transparent' : "".concat(color(bg).alpha(0)),
    boxShadow: "inset 0 0 0 1px ".concat(colors.flatGrey)
  }, "&:hover,\n      &:focus", {
    color: fontColor
  }), !link && !disabled && generateTransparentDepth({
    bg: bg,
    link: link,
    hover: hover,
    active: active,
    theme: theme
  })), link && {
    '&:focus': {
      color: darken(0.1, fontColor)
    }
  });
};